<template>
  <div class="wrap" v-show="lang">
    <Header ref="sonh" />
    <EBike v-if="platform.isPC" />
    <EBikeM v-else />
    <Footer />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import EBike from "./components/EBike";
import EBikeM from "./components/EBikeM";
import platform from "@/utils/platform";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    EBike,
    EBikeM,
  },
  computed: {
    ...mapState(["lang"]),
    isZhCN() {
      const isCN = this.lang === "zh-CN";
      return isCN;
    },
  },
  data() {
    return {
      platform,
    };
  },
  mounted() {
    if (!platform.isPC) {
      this.chen();
    }
  },
  methods: {
    chen() {
      this.$refs["sonh"].chenage();
    },
  },
};
</script>

<style lang='scss' scoped>
@import "~@assets/styles/util.scss";

.wrap {
  @extend .iphoneX;
}
</style>
